import React from 'react'
import PropTypes from 'prop-types'
import { errorMessagesByContext } from 'utils/Client/technicalDifficultiesMessage'
import styles from './TechnicalDifficultiesMessage.module.scss'

const TechnicalDifficultiesMessage = (props) => {
  const {
    layout,
    context
  } = props
  const containerClass = `${layout}ErrorContainer`
  const messageContext = errorMessagesByContext[context]
  
  return (
    <div className={styles[containerClass]}>
      <div className={styles.errorLabel}>
        {messageContext.label}
      </div>
      <div className={styles.errorSubLabel}>
        {messageContext.subLabel}
      </div>
    </div>
  )
}


TechnicalDifficultiesMessage.defaultProps = {
  layout: 'header'
}

TechnicalDifficultiesMessage.propTypes = {
  layout: PropTypes.string,
  context: PropTypes.string.isRequired
}

export default TechnicalDifficultiesMessage



// WEBPACK FOOTER //
// ./src/components/Client/TechnicalDifficultiesMessage/TechnicalDifficultiesMessage.jsx